import "./App.css";
import Template from "template/Template";
import { createTheme, ThemeProvider } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dashboard from "pages/Dashboard/Dashboard";
import CriarQuadro from "pages/Quadros/CriarQuadro/CriarQuadro";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import VerQuadros from "pages/Quadros/CriarQuadro/VerQuadros";
import CriarAnunciante from "pages/Anunciantes/CriarAnunciante";
import CriarCategoria from "pages/Categorias/CriarCategoria";
import CriarTag from "pages/Tags/CriarTag";
import CriarProduto from "pages/Produtos/CriarProduto";
import EmConstrucao from "pages/EmConstrucao/EmConstrucao";
import VideoPlaceApp from "VideoPlaceApp";

//#2e2e2e

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffdd00",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#00f7ff",
      contrastText: "#ffffff",
    },
  },
  overrides: {
    MuiButton: {
      text: {
        textDecoration: "bold",
      },
      contained: {
        borderRadius: "100px",
        color: "#ffffff",
        backgroundImage:
          "linear-gradient(90deg, #ffdd00, red, #ff00ea, blue, #00f7ff)",
        transition: "fade",
      },
    },
  },
});

const routes = [
  {
    title: "Dashboard",
    path: "/painel",
    visible: true,
    exact: true,
    component: Dashboard,
  },
  {
    title: "Criar Quadro",
    path: "/painel/criar-quadro",
    visible: true,
    exact: true,
    component: CriarQuadro,
  },
  {
    title: "Ver Quadros",
    path: "/painel/ver-quadros",
    visible: true,
    component: VerQuadros,
  },
  {
    title: "Criar Anunciate",
    path: "/painel/criar-anunciante",
    visible: true,
    component: CriarAnunciante,
  },
  {
    title: "Ver Anunciantes",
    path: "/painel/ver-anunciantes",
    visible: true,
  },
  {
    title: "Criar Categoria",
    path: "/painel/criar-categoria",
    visible: true,
    component: CriarCategoria,
  },
  {
    title: "Ver Categorias",
    path: "/painel/ver-categorias",
    visible: true,
  },
  {
    title: "Criar Tag",
    path: "/painel/criar-tag",
    visible: true,
    component: CriarTag,
  },
  {
    title: "Ver Tags",
    path: "/painel/ver-tags",
    visible: true,
  },
  {
    title: "Criar Produto",
    path: "/painel/criar-produto",
    visible: true,
    component: CriarProduto,
  },
  {
    title: "Ver Produtos",
    path: "/painel/ver-produtos",
    visible: true,
  },
];

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/" component={VideoPlaceApp} />
          <Route
            path="/painel"
            component={() => {
              return (
                <ThemeProvider theme={theme}>
                  <Template routes={routes} />
                </ThemeProvider>
              );
            }}
          />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
